import enLocale from 'element-ui/lib/locale/lang/en'
import home from './english/home'

const en = {
    language: 'English',
    message: {
        'home': {
            ...home,
            'enterEmail': 'Please enter email',
            'save': 'Save',
            'saveSuccess': 'Save successfully',
            'pointHistory': 'Points history',
            'type': 'Type',
            'remark': 'Remark',
            'pendingComment': 'Pending review',
            'commented': 'Reviewed',
            'selectDate': 'Select date',
            'loginSuccess': 'Login successful',
            'loginFail': 'Login failed',
            'close': 'Close',
            'required': 'Required',
            'nickname': 'Nickname',
            'enterNickname': 'Please enter nickname',
            'gender': 'Gender',
            'male': 'Male',
            'female': 'Female',
            'secret': 'Secret',
            'birthday': 'Birthday',
            checkoutLoadFailed: 'Checkout failed to load. Please try again.',
            checkoutErrorTitle: 'Notice',
            goAddAddress: 'Add shipping address',
            shop_order_selectOrAddAddress: 'Please add a shipping address and set it as default before checkout.',
            shop_order_cartEmpty: 'Your cart is empty.',
            shop_order_cartHasNotActive: 'Some items are invalid or inactive.',
            shop_order_cartHasNotMarketable: 'Some items are no longer available.',
            shop_order_cartHasLowStock: 'Some items are out of stock.',
            shop_order_cartHasExpiredGoods: 'Some items have expired.',
            shop_order_typeIsNull: 'Order type could not be determined.',
            shop_order_goodsNotFound: 'Product was not found or has been removed.',
            shop_order_giftNotForSale: 'Gift items cannot be purchased directly.',
            common_message_badRequest: 'Invalid request. Please check the product and parameters.',
        },
    },
    '手机号码最小长度为8位': "The minimum length of the mobile phone number is 8 digits.",
    '邮箱账号名称最小长度为6位': "The minimum length of the email account name is 6 characters.",
    '邮箱只能包含英文，数字等字符': "The Email can only contain English, numbers and other characters",
    '请选择正确的收货地址': "Please select the correct delivery address.",
    // ===== Data Dictionary I18N =====
    Dict_language_status_0: 'Disabled',
    Dict_language_status_1: 'Enabled',
    Dict_member_label_type_1: 'Condition Label',
    Dict_member_label_type_2: 'Manual Label',
    Dict_member_level_type_0: 'Consumption Level (LV)',
    Dict_member_level_type_1: 'Paid Member (VIP)',
    Dict_member_growth_action_type_1: 'Order Purchase',
    Dict_member_growth_action_type_2: 'Daily Login',
    Dict_member_growth_action_type_3: 'Post Review',
    Dict_member_growth_action_type_4: 'Complete Profile',
    Dict_paid_member_payment_type_0: 'Balance Payment',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Active',
    Dict_paid_member_record_status_1: 'Expired',
    Dict_paid_member_record_status_2: 'Refunded',
    Dict_point_lottery_prize_type_0: 'Points',
    Dict_point_lottery_prize_type_1: 'Coupon',
    Dict_point_lottery_prize_type_2: 'Physical Prize',
    Dict_point_lottery_prize_type_3: 'Thank You',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Email',
    Dict_notification_channel_type_2: 'In-site Message',
    Dict_notification_channel_type_3: 'Push Notification',
    Dict_announcement_status_0: 'Draft',
    Dict_announcement_status_1: 'Published',
    Dict_announcement_status_2: 'Unpublished',
    Dict_live_permission_status_0: 'Not Applied',
    Dict_live_permission_status_1: 'Under Review',
    Dict_live_permission_status_2: 'Activated',
    Dict_live_permission_status_3: 'Rejected',
    Dict_live_room_status_0: 'Not Started',
    Dict_live_room_status_1: 'Streaming',
    Dict_live_room_status_2: 'Ended',
    Dict_live_room_status_3: 'Abnormal Interruption',
    Dict_live_room_type_0: 'Platform Live',
    Dict_live_room_type_1: 'Merchant Live',
    Dict_store_type_0: 'Individual Store',
    Dict_store_type_1: 'Enterprise Store',
    Dict_store_sign_status_0: 'Pending Sign',
    Dict_store_sign_status_1: 'Signed',
    Dict_store_sign_status_2: 'Terminated',
    Dict_store_business_change_status_0: 'Pending Review',
    Dict_store_business_change_status_1: 'Approved',
    Dict_store_business_change_status_2: 'Rejected',
    Dict_decoration_page_type_0: 'Home Page',
    Dict_decoration_page_type_1: 'Category Page',
    Dict_decoration_page_type_2: 'Activity Page',
    Dict_decoration_page_type_3: 'Custom Page',
    Dict_decoration_status_0: 'Draft',
    Dict_decoration_status_1: 'Published',
    Dict_decoration_popup_trigger_page_0: 'Platform Home',
    Dict_decoration_popup_trigger_page_1: 'Member Center',
    Dict_decoration_popup_trigger_page_2: 'Payment Success',
    Dict_decoration_popup_target_user_0: 'All Users',
    Dict_decoration_popup_target_user_1: 'Free Members',
    Dict_decoration_popup_target_user_2: 'Paid Members',
    Dict_decoration_popup_frequency_0: 'Once Permanently',
    Dict_decoration_popup_frequency_1: 'Every Visit',
    Dict_decoration_popup_frequency_2: 'Custom Frequency',
    Dict_track_event_type_page_view: 'Page View',
    Dict_track_event_type_click: 'Click',
    Dict_track_event_type_add_to_cart: 'Add to Cart',
    Dict_track_event_type_search: 'Search',
    Dict_track_event_type_purchase: 'Purchase',
    Dict_track_event_type_live_watch: 'Watch Live',
    Dict_reconcile_period_type_0: 'Daily',
    Dict_reconcile_period_type_1: 'Weekly',
    Dict_reconcile_period_type_2: 'Monthly',
    Dict_store_settlement_status_0: 'Pending Settlement',
    Dict_store_settlement_status_1: 'Settled',
    Dict_distributor_status_0: 'Pending Review',
    Dict_distributor_status_1: 'Reviewed',
    Dict_distributor_status_2: 'Rejected',
    Dict_distribution_commission_type_0: 'Direct Commission',
    Dict_distribution_commission_type_1: 'Indirect Commission',
    Dict_configuration_status_0: 'Disabled',
    Dict_configuration_status_1: 'Enabled',
    ...enLocale
}

export default en
